import api from '@/api'

export default {
    // >> 고충처리
    getReportManagerList(type: string, comCode: string): Promise<kyoboBook.report.RoleMember[]> {
        return api.get({
            url: '/KyoboBook/KBBReport/api/managerList',
            params: {
                roleType: type,
                comCode: comCode
            }
        })
    },

    sendMailToManager(manager: kyoboBook.report.RoleMember, content: kyoboBook.report.ReportForm): Promise<any> {
        return api.post({
            url: `/KyoboBook/KBBReport/api/sendMail`,
            data: {
                manager: manager,
                content: content
            }
        })
    },
    // << 고충처리

    // >> Clean Desk
    getCheckList(date: string): Promise<kyoboBook.cleandesk.UserCheckList> {
        return api.get({
            url: `/KyoboBook/KBBCleanDesk/api/list`,
            params: {
                useDate: date
            }
        })
    },

    submitCheckList(useDate: string, checkValue: string, userCode: string): Promise<number> {
        return api.post({
            url: `/KyoboBook/KBBCleanDesk/api/submit`,
            data: {
                useDate: useDate,
                checkValue: checkValue,
                userCode: userCode
            }
        })
    },
    // << Clean Desk

    // >> 임직원구매내역
    // 오프라인
    getOfflinePurchase(startDate: string, endDate: string): Promise<string>{
        return api.get({
            url: `/KyoboBook/KBBPurchase/api/offline`,
            params:{
                startDate: startDate,
                endDate: endDate
            }
        })
    },
    // 온라인
    getOnlinePurchase(startDate: string, endDate: string): Promise<string>{
        return api.get({
            url: `/KyoboBook/KBBPurchase/api/online`,
            params:{
                startDate: startDate,
                endDate: endDate
            }
        })
    },
    // << 임직원구매내역

    // >> 메인화면 카운트
    getEHRCount(): Promise<home.count> {
        return api.get({
            url: '/KyoboBook/Home/api/getEHRCount'
        });
    },

    getIFASCount(): Promise<home.ifasCount> {
        return api.get({
            url: '/KyoboBook/Home/api/getIFASCount'
        });
    },
    // << 메인화면 카운트
}